import http from 'plugins/axios'

const prefix = '/ta/admin/tenant/monitor-strategy'
async function dataOf(request) {
  const response = await request
  if (!response || response.code !== 0) throw new Error((response && response.msg) || '请求失败')
  return response.data
}

export default {
  list: data => dataOf(http.get({ url: `${prefix}/list`, data })),
  one: id => dataOf(http.get({ url: `${prefix}/one`, data: { id } })),
  sharedOptions: data => dataOf(http.get({ url: `${prefix}/shared-options`, data })),
  sharedOne: id => dataOf(http.get({ url: `${prefix}/shared-one`, data: { id } })),
  importShared: data => dataOf(http.post({ url: `${prefix}/import`, data })),
  save: data => dataOf(http.post({ url: `${prefix}/save`, data })),
  status: data => dataOf(http.post({ url: `${prefix}/status`, data })),
  remove: id => dataOf(http.post({ url: `${prefix}/delete`, data: { id } })),
}
